var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62012 1.64746C10.1433 0.392094 11.9917 0.433608 12.4268 1.77246L13.9453 6.44629L13.9756 6.52051C14.0601 6.68521 14.2314 6.79199 14.4209 6.79199H19.335C20.7428 6.79199 21.3539 8.5374 20.3213 9.42285L20.2168 9.50488L16.2412 12.3936C16.066 12.5209 15.9926 12.7471 16.0596 12.9531L17.5781 17.627L17.6143 17.7559C17.9181 19.036 16.5044 20.0629 15.3809 19.3779L15.2695 19.3037L11.2939 16.415C11.1406 16.3037 10.9396 16.2895 10.7744 16.373L10.7061 16.415L6.73047 19.3037C5.555 20.1577 3.97322 19.0088 4.42188 17.627L5.94043 12.9531L5.95898 12.875C5.98335 12.7183 5.93198 12.5588 5.82031 12.4463L5.75879 12.3936L1.7832 9.50488C0.608023 8.65069 1.21207 6.79199 2.66504 6.79199H7.5791C7.79571 6.79199 7.98774 6.65229 8.05469 6.44629L9.57324 1.77246L9.62012 1.64746Z",
    fill: "#C32A7C",
    stroke: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar5);
export default __webpack_public_path__ + "static/media/star5.a74f252e313d1f95dac6508aad043082.svg";
export { ForwardRef as ReactComponent };